import { render, staticRenderFns } from "./ExcelExport.vue?vue&type=template&id=652641a8&scoped=true"
import script from "./ExcelExport.vue?vue&type=script&lang=js"
export * from "./ExcelExport.vue?vue&type=script&lang=js"
import style0 from "./ExcelExport.vue?vue&type=style&index=0&id=652641a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652641a8",
  null
  
)

export default component.exports